import Mutations from '../../../store/data/mutations'
export default {
  namespaced: true,
  state: {
    audits: [],
    subjects: [],
    model: null,
    filterBy: '',
    drawer: false,
    loadingAudits: false,
    loadingModels: false,
    subjectId: null
  },
  mutations: Mutations
}
